import { render, staticRenderFns } from "./customerhome.vue?vue&type=template&id=2fa3d822"
import script from "./customerhome.vue?vue&type=script&lang=js"
export * from "./customerhome.vue?vue&type=script&lang=js"
import style0 from "./customerhome.vue?vue&type=style&index=0&id=2fa3d822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports